import { render } from "./SchoolActivationPeriod.vue?vue&type=template&id=7d6da739&ts=true"
import script from "./SchoolActivationPeriod.vue?vue&type=script&lang=ts"
export * from "./SchoolActivationPeriod.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__